export const ANALYTICS_EVENTS = {
  HOMEPAGE_LOAD: 'homepage_load',

  LOCATION: 'location',
  DELIVERY_MODE: 'delivery_mode',
  SELECT_LOCATION: 'select_location',

  PRODUCT_SEARCH: 'product_search',

  BANNER_CLICKED: 'banner_clicked',

  HAMBURGER_MENU: 'hamburger_menu',
  DELIVERY_SERVICE: 'delivery_service',

  EXPLORE_MENU: 'explore_menu',

  STORE_SEARCH: 'store_search',

  CATEGORY_PLP: 'category_plp',

  PRODUCT_CLICK: 'product_click',

  VEG_NONVEG_FILTER: 'veg_nonveg_filter',

  ADD_TO_CART: 'add_to_cart',
  REMOVE_FROM_CART: 'remove_from_cart',
  VIEW_CART: 'view_cart',

  VIEW_OFFERS: 'view_offers',
  COUPON_APPLY: 'coupon_apply',
  COUPON_REMOVE: 'coupon_remove',

  ADD_ADDRESS: 'add_address',
  SET_DELIVERY_ADDRESS: 'set_delivery_address',

  CHECKOUT: 'checkout',

  MAKE_PAYMENT: 'make_payment',
  PURCHASE_COMPLETED: 'purchase_completed',

  LOGIN_ATTEMPT: 'login_attempt',
  GET_OTP: 'get_otp',
  RESEND_OTP: 'resend_otp',
  VERIFY_OTP: 'verify_otp',
  LOGIN_SUCCESSFUL: 'login_successful',

  UPDATE_USER: 'update_user',

  REDEEM_ATTEMPT: 'redeem_attempt',
  REDEEM_SUCCESSFUL: 'redeem_succesful',
  REDEEM_FAILED: 'redeem_failed',

  GET_CROWN_OFFER: 'get_crown_offer',

  SHAKE_GAME: 'shake_game',

  RATE_ORDER: 'rate_order',

  RECENT_ORDERS: 'recent_orders',

  SAVED_KINGDEALS: 'saved_kingdeals',
  EDIT_PROFILE: 'edit_profile',

  CROWN_HISTORY: 'crown_history',
  CROWN_REDEEM: 'crown_redeem',

  SETTINGS_SUPPORT_CLICK: 'settings_&_support_click',

  LOGOUT: 'logout',

  CALL_RESTAURANT: 'call_restaurant',
  CALL_RIDER: 'call_rider',

  ADD_ONS: 'add-ons',

  REGISTRATION_SUCCESSFUL: 'registration_succesfull'
};

export const customMoengageNames = {
  userId: 'identifyUser',
  name: 'name',
  firstName: 'first_name',
  lastName: 'last_name',
  gender: 'add_gender',
  email: 'add_email',
  dateOfBirth: 'date_of_birth',
  phoneNumber: 'add_mobile',
  isMember: 'is_member',
  latLng: 'location',
  city: 'city',
  state: 'state',
  lastLoginDate: 'last_login_date',
  registrationDate: 'registration_date',
  orderMode: 'order_mode',
  expiryDate: 'expiry_date',
  birthdayMonth: 'birthday_month',
  crownPoints: 'crown_points'
};
